import React from 'react';

const Pagination = ({ items, numberOfPages, setter, currentPage }) => {
  const paginationNumbers = [];

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  for (let i = 0; i < numberOfPages; i++) {
    const el = (
      <li className="o-pagination__item" key={`pagination-item--${i + 1}`}>
        {currentPage !== i ? (
          <a
            onClick={() => {
              setter(i);
              scrollToTop();
            }}
            className="o-pagination__list__link u-pointer"
            title={i + 1}
          >
            {i + 1}
          </a>
        ) : (
          <>{i + 1}</>
        )}
      </li>
    );

    paginationNumbers.push(el);
  }

  if (items.length > 0) {
    return (
      <div className="o-pagination u-pt-6 u-pb-6 u-pb-8@tablet u-pb-10@tablet-wide">
        {numberOfPages > 1 && (
          <a
            onClick={() => {
              setter((p) => p - 1);
              scrollToTop();
            }}
            className="o-pagination__arrow o-pagination__arrow--back u-pointer"
          >
            <span className="u-a11y">Prev</span>
          </a>
        )}

        <ul className="o-pagination__list">{paginationNumbers}</ul>

        {numberOfPages > 1 && (
          <a
            onClick={() => {
              setter((p) => p + 1);
              scrollToTop();
            }}
            className="o-pagination__arrow o-pagination__arrow--next u-pointer"
          >
            <span className="u-a11y">Next</span>
          </a>
        )}
      </div>
    );
  }
};

export default Pagination;
